import { useState, useEffect } from "react";
import FinancialModelAWS from "../../stacks/financialModel/FinancialModelAWS";

export const useGetScenarios = (options={},cb) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!options.manual) {
      refetch();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function refetch() {
    try {
      const financialModelApi = FinancialModelAWS.getInstance();
      const fin = await financialModelApi.retrieveForecast();
      setData(fin);
      setError("");
      setLoading(false);
      cb && cb(fin)
    } catch (err) {
      console.log(`ERROR getting forecasts ${err.message}`);
      setError(err.message);
      setLoading(false);
    }
  }

  return [{ loading, error, data }, refetch];
};
